export default {
    methods: {
        cloneDuplicateStep(step) {
            let newStep = JSON.parse(JSON.stringify(step));
            return this.duplicateNewStep(newStep);
        },
        duplicateNewStep(newStep) {
            newStep.id = null;
            newStep.version = 0;
            newStep.fields.forEach(field => {
                this.duplicateNewField(field);
            });
            return newStep;
        },
        cloneDuplicateField(field) {
            let newField = JSON.parse(JSON.stringify(field));
            return this.duplicateNewField(newField);
        },
        duplicateNewField(newField) {
            newField.id = null;
            newField.version = 0;
            if (newField.fieldValues && newField.fieldValues.length > 0) {
                newField.fieldValues.forEach(fv => {
                    fv.id = null;
                    fv.version = 0;
                });
            }
            if (newField.stepCreation != null) {
                newField.stepCreation = this.duplicateNewStep(newField.stepCreation);
            }
            return newField;
        },
    }
}